export const getCurrentStudyProgram = (user, rateId) =>
  user.studyPrograms?.filter((sp) => sp.typeId === rateId)[0];
